export default () => ({
    button: {
        marginLeft: 170,
    },
    formControl: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0,
        '&::before': {
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            position: 'absolute',
            transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            pointerEvents: 'none',
        },
        '&::after': {
            left: 0,
            right: 0,
            bottom: 0,
            content: '""',
            position: 'absolute',
            transform: 'scaleX(0)',
            transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            pointerEvents: 'none',
        },
    },
    postComponent: {
        display: 'none',
    },
    input: {
        width: 50,
    },
    inputComponents: {
        background: 'none',
        padding: 0,
    },
    adviceContainer: {
        marginTop: 15,
    },
});
